import { SidePanelTsoPq } from '@components/Grid/SidePanelTsoPq';
import { useTranslation } from 'react-i18next';
import SidePanelParameters from './SidePanelComponents/SidePanelParameters';
import SubmittedCalculations from './SidePanelComponents/SubmittedCalculations';

const TrendIdentificationSidePanel = () => {
  const { t } = useTranslation();
  return (
    <SidePanelTsoPq
      sectionTitle={t('trendIdentification.sidePanel.title')}
      firstSlot={<SubmittedCalculations />}
      secondSlot={<SidePanelParameters />}
    ></SidePanelTsoPq>
  );
};
export default TrendIdentificationSidePanel;
